import { useField } from 'formik';
import { FormCheck } from 'react-bootstrap';
import PropTypes from 'prop-types';

function FormSwitchButton({ name, label, description }) {
  const [field] = useField(name);

  const descriptionView = description && (
    <div style={{ paddingBottom: 10 }}>{description}</div>
  );

  return (
    <>
      {descriptionView}
      <FormCheck
        checked={field.value}
        type="switch"
        id={name}
        label={label}
        {...field}
      />
    </>
  );
}

FormSwitchButton.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
};

export default FormSwitchButton;
